import React, { Component } from "react";
import { UserConsumer } from "../../UserContext";
import Header from "../timesheetModule/Header";
import "./dashboard.scss";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";
import {
	title,
	lineOptions,
	lineOptionsByWeek,
	TimesheetPerformanceLineChart,
	APIDateFormat,
} from "./DashboardVariables";
import axios from "axios";
import moment from "moment";
import { Dashboard_APIs } from "./DashboardAPIs";
import CustomReactSelect from "../../components/CustomReactSelect";
import { Col, Input, Label, Row, Spinner } from "reactstrap";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { Routes } from "../../configurations/config";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

let token,
	empJoinedOn,
	department,
	empDesignation,
	employeeId = null;
const currentYear = new Date().getFullYear();
const groupByList = [
	{ value: 1, label: "Week" },
	{ value: 2, label: "Month" },
];
let timesheetMarker = {
	symbol: "circle",
	fillColor: "white",
	lineColor: null,
	lineWidth: 2,
};
const monthsList = [
	{ value: 0, label: "All" },
	{ value: 1, label: "January" },
	{ value: 2, label: "February" },
	{ value: 3, label: "March" },
	{ value: 4, label: "April" },
	{ value: 5, label: "May" },
	{ value: 6, label: "June" },
	{ value: 7, label: "July" },
	{ value: 8, label: "August" },
	{ value: 9, label: "September" },
	{ value: 10, label: "October" },
	{ value: 11, label: "November" },
	{ value: 12, label: "December" },
];
class CMDashboard extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
		this.TimesheetPerLinechart = React.createRef();
		this.state = {
			workStationGraph: { ...lineOptionsByWeek },
			attendanceGraph: { ...lineOptions },
			lateComingGraph: { ...lineOptions },
			leavesGraph: { ...lineOptions },
			workFromHome: [],
			workFromOffice: [],
			continueWorkFromOffice: [],
			WFxCategoris: [],
			workStationOption: [
				{ value: 1, label: "Day" },
				{ value: 2, label: "Week" },
				{ value: 3, label: "Month" },
			],
			workStationGraphLoading: true,
			attendanceGraphLoading: true,
			leavesGraphLoading: true,
			lateComingGraphLoading: true,
			selectedWorkStationOption: null,
			WorkStationYearList: [],
			selectedWorkStationYear: [],
			showWorkStationCalendar: false,
			defaultInputRange: {
				start: moment(new Date()).subtract(2, "weeks"),
				end: moment(new Date()),
			},
			onYearChangeSelection: false,
			WorkStationCalendarRange: null,
			WorkStationCalendarRangeLabel: null,
			enableWorkStationRangePicker: false,
			timesheetPerformanceLineChartLoading: true,
			TimesheetPerformanceLineChart: {
				...TimesheetPerformanceLineChart,
			},
			performanceLineChartData: [],
			TimesheetPerformanceMEE: [],
			TimesheetPerformanceMEPlus: [],
			TimesheetPerformanceME: [],
			TimesheetPerformanceMEMinus: [],
			TimesheetPerformanceFME: [],
			TimesheetPerformanceCategories: [],
			TimesheetPerformanceSelectedGrouBy: groupByList[0],
			timesheetPerformanceSelectedYear: {
				value: currentYear,
				label: currentYear.toString(),
			},
			timesheetPerformanceSelectedMonth: monthsList[0],
			employeesList: [],
			selectedEmployee: null,
		};
	}
	componentDidMount() {
		let categories = [],
			data = [],
			temp,
			temp1,
			temp2,
			tempWS,
			lateComming = [],
			lateSitting = [],
			month = [],
			compensationLeavesCount = [],
			sickLeavesCount = [],
			annualLeavesCount = [],
			headers = {
				Authorization: `Bearer ${token}`,
			},
			marker = {
				symbol: "circle",
				fillColor: "white",
				lineColor: null,
				lineWidth: 2,
			};

		//get employee list
		this.getEmployeeList();
		// Get Work Station API
		const years = [];
		do {
			years.unshift({
				value: empJoinedOn,
				label: empJoinedOn.toString(),
			});
			empJoinedOn++;
		} while (empJoinedOn != currentYear + 1);

		this.setState({
			selectedWorkStationOption: { value: 2, label: "Week" },
			selectedWorkStationYear: {
				value: currentYear,
				label: currentYear.toString(),
			},
			WorkStationYearList: years,
		});

		//Get WorkStation Data for Graph
		let start = moment(new Date(moment().subtract(2, "weeks"))).format(
			APIDateFormat
		);
		let end = moment(new Date()).format(APIDateFormat);
		axios
			.get(
				`${Dashboard_APIs.GetAllWorkStationCount_API}?GroupBy=2&StartDate=${start}&EndDate=${end}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				res.data.workStationChart.forEach((item, index) => {
					this.state.WFxCategoris.push(
						moment(item.title).format("DD MMM YY")
					);
					this.state.workFromOffice.push(item.workFromOffice);
					this.state.workFromHome.push(item.workFromHome);
					this.state.continueWorkFromOffice.push(
						item.continuingWorkFromOffice
					);
				});

				temp1 = {
					name: "Work From Office",
					data: this.state.workFromOffice,
					marker: marker,
				};
				temp = {
					name: "Work From Home",
					data: this.state.workFromHome,
					marker: marker,
				};
				tempWS = {
					name: "Continuing Work From Office",
					data: this.state.continueWorkFromOffice,
					marker: marker,
				};
				this.setState((prevState) => {
					let workStationGraph = Object.assign(
						{},
						prevState.workStationGraph
					);
					workStationGraph.xAxis.categories = this.state.WFxCategoris;
					workStationGraph.xAxis.title = {
						text:
							moment(this.state.defaultInputRange.start).format(
								"DD MMM YYYY"
							) +
							" -> " +
							moment(this.state.defaultInputRange.end).format(
								"DD MMM YYYY"
							),
					};
					workStationGraph.series = [];
					workStationGraph.series.push(temp1, temp, tempWS);
					return { workStationGraph };
				});
				this.setState({
					workStationGraphLoading: false,
				});
			});

		axios
			.get(`${Dashboard_APIs.GetAllEmployeesAttendance_API}`, {
				headers: headers,
			})
			.then((res) => {
				res.data.forEach((item) => {
					categories.push(moment(item.date).format("DD MMMM "));
					data.push(item.attendance);
				});
				temp = { name: "Attendance", data: data, marker: marker };
				this.setState((prevState) => {
					let attendanceGraph = Object.assign(
						{},
						prevState.attendanceGraph
					);
					attendanceGraph.xAxis.categories = categories;
					attendanceGraph.series = [];
					attendanceGraph.series.push(temp);
					return { attendanceGraph };
				});
				this.setState({
					attendanceGraphLoading: false,
				});
			});

		axios
			.get(`${Dashboard_APIs.AllEmployeesLateCommingLateSitting_API}`, {
				headers: headers,
			})
			.then((res) => {
				res.data.forEach((item) => {
					categories.push(moment(item.date).format("DD MMMM "));
					lateComming.push(item.lateComming);
					lateSitting.push(item.lateSitting);
				});
				temp1 = {
					name: "Late Coming",
					data: lateComming,
					marker: marker,
					point: {
						events: {
							click: (function (component) {
								return function (event) {
									component.lateCominLateSittingGraphRedirection(
										event.point.category,
										"/CheckInCheckOut",
										"lateComingLateSitting",
										{ value: 3, label: "Late Coming" },
										"date",
										event.point.category
									);
								};
							})(this),
						},
					},
				};
				temp = {
					name: "Late Sitting",
					data: lateSitting,
					marker: marker,
					point: {
						events: {
							click: (function (component) {
								return function (event) {
									component.lateCominLateSittingGraphRedirection(
										event.point.category,
										"/CheckInCheckOut",
										"lateComingLateSitting",
										{ value: 9, label: "Late Sitting" },
										"date",
										event.point.category
									);
								};
							})(this),
						},
					},
				};
				this.setState((prevState) => {
					let lateComingGraph = Object.assign(
						{},
						prevState.lateComingGraph
					);
					lateComingGraph.xAxis.categories = categories;
					lateComingGraph.series = [];
					lateComingGraph.series.push(temp1, temp);
					return { lateComingGraph };
				});
				this.setState({
					lateComingGraphLoading: false,
				});
			});

		axios
			.get(`${Dashboard_APIs.LeavesGraphForWholeYear_API}`, {
				headers: headers,
			})
			.then((res) => {
				res.data.forEach((item) => {
					month.push(item.month);
					annualLeavesCount.push(item.annualLeavesCount);
					sickLeavesCount.push(item.sickLeavesCount);
					compensationLeavesCount.push(item.compensationLeavesCount);
				});
				temp2 = {
					name: "Annual",
					data: annualLeavesCount,
					marker: marker,
				};
				temp = { name: "Sick", data: sickLeavesCount, marker: marker };
				temp1 = {
					name: "Compensation",
					data: compensationLeavesCount,
					marker: marker,
				};
				for (let i = 0; i < month.length; i++)
					month[i] = month[i].substring(0, 3);
				this.setState((prevState) => {
					let leavesGraph = Object.assign({}, prevState.leavesGraph);
					leavesGraph.xAxis.categories = month;
					leavesGraph.series = [];
					leavesGraph.series.push(temp2, temp, temp1);
					return { leavesGraph };
				});
				this.setState({
					leavesGraphLoading: false,
				});
			});
		//Get timesheetPerformanceData for line graph
		this.getTimesheetPerformanceLineChartAPI(currentYear, 0, 0);
	}
	lateCominLateSittingGraphRedirection = (
		event,
		route,
		stateName,
		stateValue,
		stateName2,
		stateValue2
	) => {
		sessionStorage.removeItem("TopBarTab");
		sessionStorage.removeItem("TopBarItem");
		sessionStorage.setItem("NavbarTab", "SupervisorTasks");
		sessionStorage.setItem("NavbarItem", "CheckInCheckOut");
		if (stateName) {
			if (stateName2)
				return this.props.history?.push({
					pathname: route,
					state: {
						[stateName]: stateValue,
						[stateName2]: stateValue2,
					},
				});
			else
				return this.props.history?.push({
					pathname: route,
					state: {
						[stateName]: stateValue,
					},
				});
		} else return this.props.history?.push(`/CheckInCheckOut/CM=${event}`);
	};
	getEmployeeList = () => {
		if (
			department === "5" || //Accounts
			department === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" || //Abdullah
			employeeId?.toString() === "42" //Umer khan
		) {
			axios
				.get(`${Dashboard_APIs.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					this.setState({
						employeesList: list,
						selectedEmployee: allEmp,
					});
				});
		} else {
			axios
				.get(`${Dashboard_APIs.GetSupervisorsEmployeesList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					this.setState({
						employeesList: list,
						selectedEmployee: allEmp,
					});
				});
		}
	};
	redirectionFromDashboardTo = (
		navBarItem,
		navBarTab,
		route,
		stateName,
		stateValue
	) => {
		UpdateNavBarItem(navBarItem);
		UpdateNavBarTab(navBarTab);
		sessionStorage.setItem("NavbarTab", navBarTab);
		sessionStorage.setItem("NavbarItem", navBarItem);
		if (stateName) {
			return this.props.history?.push({
				pathname: Routes.TimesheetPerformanceReport,
				state: {
					[stateName]: stateValue,
				},
			});
		} else if (route) {
			return this.props.history?.push(route);
		}
	};
	getTimesheetPerformanceLineChartAPI = (year, month, employee, groupBy) => {
		let label = "";
		this.state.TimesheetPerformanceMEE = [];
		this.state.TimesheetPerformanceMEPlus = [];
		this.state.TimesheetPerformanceME = [];
		this.state.TimesheetPerformanceMEMinus = [];
		this.state.TimesheetPerformanceFME = [];
		this.state.TimesheetPerformanceCategories = [];
		let chartObj = this?.TimesheetPerLinechart?.current?.chart;
		if (chartObj) chartObj.showLoading();
		let apiUrl = `${
			Dashboard_APIs.GetMyTeamTimesheetScoreLineChart
		}?showAllEmployees=true&Month=${month}&Year=${year}&EmployeeId=${employee}&GroupBy=${
			groupBy || 1
		}`;
		axios
			.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				res.data.timesheetScoreObjects.forEach((item) => {
					if (groupBy === 2) {
						this.state.TimesheetPerformanceCategories.push(
							item.title
						);
					} else {
						this.state.TimesheetPerformanceCategories.push(
							moment(item.title).format("DD MMMM YY")
						);
					}

					item.scoreList.map((score) => {
						let scoreObj = {
							name: score.score,
							y: score.count,
						};
						switch (score.numericScore) {
							case 5:
								this.state.TimesheetPerformanceMEE.push(
									scoreObj
								);
								break;
							case 4:
								this.state.TimesheetPerformanceMEPlus.push(
									scoreObj
								);
								break;
							case 3:
								this.state.TimesheetPerformanceME.push(
									scoreObj
								);
								break;
							case 2:
								this.state.TimesheetPerformanceMEMinus.push(
									scoreObj
								);
								break;
							case 1:
								this.state.TimesheetPerformanceFME.push(
									scoreObj
								);
								break;
							default:
								break;
						}
					});
				});

				let MEE = {
					name: "MEE",
					data: this.state.TimesheetPerformanceMEE,
					marker: timesheetMarker,
				};
				let MEPlus = {
					name: "ME+",
					data: this.state.TimesheetPerformanceMEPlus,
					marker: timesheetMarker,
				};
				let ME = {
					name: "ME",
					data: this.state.TimesheetPerformanceME,
					marker: timesheetMarker,
				};
				let MEMinus = {
					name: "ME-",
					data: this.state.TimesheetPerformanceMEMinus,
					marker: timesheetMarker,
				};
				let FME = {
					name: "FME",
					data: this.state.TimesheetPerformanceFME,
					marker: timesheetMarker,
				};
				this.setState((prevState) => {
					let TimesheetPerformanceLineChart = Object.assign(
						{},
						prevState.TimesheetPerformanceLineChart
					);
					TimesheetPerformanceLineChart.xAxis.categories =
						this.state.TimesheetPerformanceCategories;
					TimesheetPerformanceLineChart.xAxis.title = {
						text: label + " " + year,
					};
					TimesheetPerformanceLineChart.series = [];
					TimesheetPerformanceLineChart.series.push(
						MEE,
						MEPlus,
						ME,
						MEMinus,
						FME
					);
					return { TimesheetPerformanceLineChart };
				});
				this.setState({
					timesheetPerformanceLineChartLoading: false,
				});
				if (chartObj) chartObj.hideLoading();
			});
	};
	onWorkStationOptionChange = (groupBy) => {
		if (groupBy.label === "Day") {
			let start = `${this.state.selectedWorkStationYear.value}-1-1`;
			let end = `${this.state.selectedWorkStationYear.value}-12-31`;
			this.setState({
				enableWorkStationRangePicker: true,
				WorkStationCalendarRange: moment.range(
					moment(new Date(start)).clone(),
					moment(new Date(end)).clone()
				),
				WorkStationCalendarRangeLabel: {
					start: moment(new Date(start)),
					end: moment(new Date(end)),
				},
			});
		} else {
			this.setState({
				enableWorkStationRangePicker: false,
			});
		}
		this.setState({
			selectedWorkStationOption: groupBy,
			showWorkStationCalendar: false,
		});
		this.getWorkStationAPI(
			groupBy,
			this.state.selectedWorkStationYear.value
		);
	};

	getWorkStationAPI = (groupBy, year, onYearChange, rangeSelection) => {
		let label = "";
		this.state.WFxCategoris = [];
		this.state.workFromOffice = [];
		this.state.workFromHome = [];

		let chartObj = this.chart.current.chart;
		chartObj.showLoading();

		let start = `${year}-1-1`;
		let end = `${year}-12-31`;

		if (onYearChange) {
			label = this.state.selectedWorkStationOption.label;
			this.setState({
				selectedWorkStationYear: { value: year, label: year },
				WorkStationCalendarRange: moment.range(
					moment(new Date(start)).clone(),
					moment(new Date(end)).clone()
				),
				onYearChangeSelection: true,
				WorkStationCalendarRangeLabel: {
					start: moment(new Date(start)),
					end: moment(new Date(end)),
				},
			});
		} else if (rangeSelection) {
			start = moment(rangeSelection.start._i).format(APIDateFormat);
			end = moment(rangeSelection.end._i).format(APIDateFormat);
		} else {
			label = groupBy.label;
			if (this.state.WorkStationCalendarRange) {
				start = moment(
					this.state.WorkStationCalendarRange.start._i
				).format(APIDateFormat);
				end = moment(this.state.WorkStationCalendarRange.end._i).format(
					APIDateFormat
				);
			} else {
				start = moment(this.state.defaultInputRange.start).format(
					APIDateFormat
				);
				end = moment(this.state.defaultInputRange.end).format(
					APIDateFormat
				);
			}
		}

		let apiUrl = "";

		if (this.state.enableWorkStationRangePicker)
			apiUrl = `${Dashboard_APIs.GetAllWorkStationCount_API}?GroupBy=${groupBy.value}&StartDate=${start}&EndDate=${end}`;
		else
			apiUrl = `${Dashboard_APIs.GetAllWorkStationCount_API}?GroupBy=${
				groupBy.value
			}&StartDate=${`${year}-1-1`}&EndDate=${`${year}-12-31`}`;

		axios
			.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				res.data.workStationChart.forEach((item, index) => {
					if (groupBy.label === "Month")
						this.state.WFxCategoris.push(
							moment(item.title).format("MMMM ")
						);
					else if (groupBy.label != "Month")
						this.state.WFxCategoris.push(
							moment(item.title).format("DD MMM YY")
						);
					else
						this.state.WFxCategoris.push(
							moment(item.title).format("DD MMMM ")
						);
					this.state.workFromOffice.push(item.workFromOffice);
					this.state.workFromHome.push(item.workFromHome);
					this.state.continueWorkFromOffice.push(
						item.continuingWorkFromOffice
					);
				});
				let temp1 = {
					name: "Work From Office",
					data: this.state.workFromOffice,
				};
				let temp = {
					name: "Work From Home",
					data: this.state.workFromHome,
				};
				let tempWS = {
					name: "Continuing Work From Office",
					data: this.state.continueWorkFromOffice,
				};
				this.setState((prevState) => {
					let workStationGraph = Object.assign(
						{},
						prevState.workStationGraph
					);
					workStationGraph.xAxis.categories = this.state.WFxCategoris;
					if (this.state.WorkStationCalendarRange) {
						workStationGraph.xAxis.title = {
							text:
								moment(
									this.state.WorkStationCalendarRange.start
								).format("DD MMM YYYY") +
								" -> " +
								moment(
									this.state.WorkStationCalendarRange.end
								).format("DD MMM YYYY"),
						};
					} else
						workStationGraph.xAxis.title = {
							text: label + " " + year,
						};
					workStationGraph.series = [];
					workStationGraph.series.push(temp1, temp, tempWS);
					return { workStationGraph };
				});
				this.setState({
					workStationGraphLoading: false,
				});
				if (chartObj) chartObj.hideLoading();
			});
	};
	handleDateRangePicker = (range) => {
		let start = moment(range.start._i).format("DD MMM YYYY");
		let end = moment(range.end._i).format("DD MMM YYYY");
		let year = moment(range.end._i).format("YYYY");

		this.setState({
			showWorkStationCalendar: false,
			WorkStationCalendarRange: moment.range(
				moment(new Date(start)).clone(),
				moment(new Date(end)).clone()
			),
			selectedWorkStationYear: {
				value: parseInt(year),
				label: year,
			},
			WorkStationCalendarRangeLabel: {
				start: moment(new Date(start)),
				end: moment(new Date(end)),
			},
		});
		this.getWorkStationAPI(
			this.state.selectedWorkStationOption,
			this.state.selectedWorkStationYear,
			null,
			range
		);
	};

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					employeeId = userDetails.id;
					empDesignation = userDetails.designation;
					department = userDetails.department;
					empJoinedOn = userDetails.empJoinedOn.split("-")[0];
					return (
						<div className="container-fluid pl-4 pr-4">
							<Header title={title(userDetails)} />

							<div className="container-fluid">
								<div className=" contentClass">
									<div className="col-md-3 col-sm-3 p-2 title">
										Timesheets Performance Report
									</div>
									<Row className="mb-2 mr-2 d-flex align-items-baseline justify-content-end">
										<Label className="mr-2">Year: </Label>
										<div
											className="mr-3"
											style={{
												zIndex: 100,
											}}
										>
											<CustomReactSelect
												className="CMYearDropdown"
												options={
													this.state
														.WorkStationYearList
												}
												onChange={(event) => {
													let value = event.value;
													this.setState({
														timesheetPerformanceSelectedYear:
															{
																value: value,
																label: value.toString(),
															},
													});
													this.getTimesheetPerformanceLineChartAPI(
														value,
														this.state
															.timesheetPerformanceSelectedMonth
															.value,
														this.state
															.selectedEmployee
															.value
													);
												}}
												value={
													this.state
														.timesheetPerformanceSelectedYear
												}
												placeholder="Year"
												paginationDropDown={true}
											/>
										</div>
										<Label className="mr-2">Month: </Label>
										<div
											className="mr-3"
											style={{
												zIndex: 100,
											}}
										>
											<CustomReactSelect
												className="CMYearDropdown"
												placeholder="Month"
												options={monthsList}
												value={
													this.state
														.timesheetPerformanceSelectedMonth
												}
												paginationDropDown={true}
												onChange={(event) => {
													let value = event.value;
													this.setState({
														timesheetPerformanceSelectedMonth:
															event,
													});
													this.getTimesheetPerformanceLineChartAPI(
														this.state
															.timesheetPerformanceSelectedYear
															.value,
														value,
														this.state
															.selectedEmployee
															.value
													);
												}}
											/>
										</div>
										<Label className="mr-2">
											Employee:{" "}
										</Label>
										<div
											className="mr-3"
											style={{
												zIndex: 100,
											}}
										>
											<CustomReactSelect
												className="CMYearDropdown"
												paginationDropDown={true}
												options={
													this.state.employeesList
												}
												value={
													this.state.selectedEmployee
												}
												onChange={(event) => {
													let value = event.value;
													this.setState({
														selectedEmployee: event,
													});
													this.getTimesheetPerformanceLineChartAPI(
														this.state
															.timesheetPerformanceSelectedYear
															.value,
														this.state
															.timesheetPerformanceSelectedMonth
															.value,
														value
													);
												}}
											/>
										</div>
										<Label className="mr-2">
											Group By:{" "}
										</Label>
										<div
											className="mr-3"
											style={{
												zIndex: 100,
											}}
										>
											<CustomReactSelect
												className="CMYearDropdown"
												paginationDropDown={true}
												options={groupByList}
												value={
													this.state
														.TimesheetPerformanceSelectedGrouBy
												}
												onChange={(event) => {
													let value = event.value;
													this.setState({
														TimesheetPerformanceSelectedGrouBy:
															event,
													});
													this.getTimesheetPerformanceLineChartAPI(
														this.state
															.timesheetPerformanceSelectedYear
															.value,
														this.state
															.timesheetPerformanceSelectedMonth
															.value,
														this.state
															.selectedEmployee
															.value,
														value,
														"onGroupByChange"
													);
												}}
											/>
										</div>
									</Row>
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs ">
										{this.state
											.timesheetPerformanceLineChartLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<>
												<PieChart
													highcharts={Highcharts}
													options={
														this.state
															.TimesheetPerformanceLineChart
													}
													ref={
														this
															.TimesheetPerLinechart
													}
												/>
											</>
										)}
									</div>
								</div>
								<div className="row mt-5 contentClass">
									<div
										className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 mb-3 d-flex"
										style={{
											justifyContent: "space-between",
										}}
									>
										<Row
											className="d-flex col-12"
											style={{
												justifyContent: "space-between",
											}}
										>
											<Col className="col-3 pl-0">
												<div className="title">
													Work Station
												</div>
											</Col>
											<Row>
												<Col
													className="pr-0"
													style={{
														zIndex: 100,
													}}
												>
													<CustomReactSelect
														className="CMYearDropdown"
														options={
															this.state
																.workStationOption
														}
														onClick={() => {
															this.setState({
																showWorkStationCalendar: false,
															});
														}}
														onChange={(event) =>
															this.onWorkStationOptionChange(
																event
															)
														}
														placeholder="Select"
														value={
															this.state
																.selectedWorkStationOption
														}
														paginationDropDown={
															true
														}
													/>
												</Col>
												<Col
													className="pr-0"
													style={{
														zIndex: 100,
													}}
												>
													<CustomReactSelect
														className="CMYearDropdown"
														options={
															this.state
																.WorkStationYearList
														}
														onChange={(event) => {
															this.setState({
																showWorkStationCalendar: false,
															});
															this.getWorkStationAPI(
																this.state
																	.selectedWorkStationOption,
																event.value,
																"onYearChange"
															);
														}}
														placeholder="Select"
														value={
															this.state
																.selectedWorkStationYear
														}
														paginationDropDown={
															true
														}
													/>
												</Col>
												<Col className="pr-0">
													<Input
														style={{
															fontSize: "14px",
															width: "215px",
															paddingTop: "10px",
															paddingBottom:
																"10px",
														}}
														className={`${
															this.state
																.enableWorkStationRangePicker
																? "rangePicker"
																: "disabledRangePicker"
														}`}
														disabled={
															!this.state
																.enableWorkStationRangePicker
														}
														readOnly={true}
														value={
															this.state
																.WorkStationCalendarRange
																? this.state.WorkStationCalendarRangeLabel.start.format(
																		"DD MMM YYYY"
																  ) +
																  " -> " +
																  this.state.WorkStationCalendarRangeLabel.end.format(
																		"DD MMM YYYY"
																  )
																: `${this.state.defaultInputRange.start.format(
																		"DD MMM YYYY"
																  )} -> ${this.state.defaultInputRange.end.format(
																		"DD MMM YYYY"
																  )}`
														}
														onClick={() => {
															this.state
																.enableWorkStationRangePicker &&
																this.setState({
																	showWorkStationCalendar: true,
																});
														}}
													/>
												</Col>
											</Row>
										</Row>
									</div>

									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs">
										{this.state.workStationGraphLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<>
												{this.state
													.showWorkStationCalendar ? (
													<div
														style={{
															position:
																"relative",
															zIndex: "1",
															float: "right",
														}}
													>
														<DateRangePicker
															id="rangePickerCalendar"
															rangeColors={
																"#068587"
															}
															selectionType="range"
															minimumDate={
																new Date(
																	empJoinedOn
																)
															}
															maximumDate={
																new Date()
															}
															stateDefinitions={
																this
																	.stateDefinitions
															}
															dateStates={
																this.dateRanges
															}
															value={
																this.state
																	.WorkStationCalendarRange
																	? this.state
																			.WorkStationCalendarRange
																	: moment.range(
																			moment()
																				.clone()
																				.subtract(
																					14,
																					"days"
																				),
																			moment().clone()
																	  )
															}
															onSelect={
																this
																	.handleDateRangePicker
															}
														/>
													</div>
												) : null}

												<PieChart
													highcharts={Highcharts}
													options={
														this.state
															.workStationGraph
													}
													ref={this.chart}
												/>
											</>
										)}
									</div>
								</div>
								<div className="row mt-5 contentClass">
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 mb-3 title">
										Daily Attendance
									</div>
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs">
										{this.state.attendanceGraphLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<PieChart
												highcharts={Highcharts}
												options={
													this.state.attendanceGraph
												}
											/>
										)}
									</div>
								</div>
								<div className="row mt-5 contentClass">
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 mb-3 title">
										Yearly Leave Graph
									</div>
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs">
										{this.state.leavesGraphLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<PieChart
												highcharts={Highcharts}
												options={this.state.leavesGraph}
											/>
										)}
									</div>
								</div>
								<div className="row mt-5 contentClass">
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 mb-3 title">
										Late Comings/Late Sittings
									</div>
									<div className="col-sm-12 col-md-12 col-sm-12 mt-2 mt-md-0 cmGraphs">
										{this.state.lateComingGraphLoading ? (
											<div className="graphLoadingSpinner">
												<Spinner />
											</div>
										) : (
											<PieChart
												highcharts={Highcharts}
												options={
													this.state.lateComingGraph
												}
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					);
				}}
			</UserConsumer>
		);
	}
}
export default CMDashboard;
